import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LazyLoad from 'react-lazy-load';
import AtfContent from 'components_library/molecules/AtfContent/AtfContent';
import classNames from 'classnames';
import _get from 'lodash.get';
import _isEqual from 'lodash.isequal';
import jsonp from 'jsonp';
import getVideoFeedUrl from 'helpers/feeds/videoHelpers';
//import Link from 'components/Link';
import Carousel from 'components/Carousel';
import Videocard from 'components/items/videocard';
import LinksList from 'components/items/LinksList';
import Pagination from 'components/Pagination/Pagination';
import { runAbExperiment } from 'utils/experimentUtils';
import fetchExperimentRelatedVideos from 'utils/relatedVideoExperimentUtil';
import { toggleLoginBox } from 'components/Login/redux';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import * as cookie from '../../utils/cookies';
import s from './CategoryListing.scss';
import makeRequest from '../../utils/makeRequest';
import AdCaller from '../../helpers/ads/adCaller';
import { bindGa } from '../../helpers/analytics';
import Heading from './Heading';
import { userVideoDataJson, isTablet, isLandscape } from '../../utils/common';
import { TOI_DEV_DOMAIN, TOI_LIVE_DOMAIN } from '../../constants';

class CategoryListing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: props.category,
      showCarouselNextLoader: false,
      showSectionChangeLoader: false,
    };
    this.getSubsectionItems = this.getSubsectionItems.bind(this);
  }

  componentDidMount() {
    const { abAdskey, abTestExperimentId } = this.props;
    const { abVSInsertId = '' } = abTestExperimentId || {};
    runAbExperiment(abVSInsertId, abAdskey, {
      1: fetchExperimentRelatedVideos.bind(this),
    });
  }

  componentDidUpdate(prevProps) {
    if (!_isEqual(prevProps.geoData, this.props.geoData)) {
      const { category } = this.state;
      const { geoData } = this.props;
      let msidToCompare = '';
      if (
        category.sections &&
        !this.props.isWapView &&
        geoData &&
        category.geo
      ) {
        msidToCompare = _get(geoData, category.geo, undefined);
        if (msidToCompare) {
          let indexClicked;
          category.sections.forEach((section, index) => {
            if (msidToCompare === section.msid) {
              indexClicked = index;
            }
          });
          if (indexClicked) {
            this.getSubsectionItems(null, indexClicked);
          }
        }
      }
    }
    if (!_isEqual(prevProps.category, this.props.category)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        category: this.props.category,
      });
    }
  }

  addToWatchLater = () => {
    const { userData } = this.props;
    if (!(userData && userData.isLoggedIn)) {
      this.props.toggleLoginBox(true);
    }
  };
  removeFromWatchLater = () => {
    const { userData } = this.props;
    if (!(userData && userData.isLoggedIn)) {
      this.props.toggleLoginBox(true);
    }
  };

  getItems = (path, perpage, curpg) => {
    //let curpg = parseInt(pgInfo.cp, 10);
    //curpg += 1;

    const url = getVideoFeedUrl({ path, perpage, curpg, reqtype: 'xhr' });
    // url += `path=${path}&perpage=${perpage}&curpg=${curpg}&reqtype=xhr`;
    // if (this.props.isWapView) {
    //   url += '&ismobile=true';
    // }
    if (typeof this.props.incrementAdsCounter === 'function') {
      this.props.incrementAdsCounter();
    }

    return makeRequest.get(url, { isMobile: this.props.isWapView });
  };

  getItemsEtimesVs = msid => {
    const videoUrlXSTfeed = __PROD__ ? TOI_LIVE_DOMAIN : TOI_DEV_DOMAIN;
    const url = `${videoUrlXSTfeed}/feeds/web_xml_feed_news_list/feedtype-sjson,msid-${msid},tag-videolistroot.cms`;
    if (typeof this.props.incrementAdsCounter === 'function') {
      this.props.incrementAdsCounter();
    }

    return makeRequest.get(url, { isMobile: this.props.isWapView });
  };

  @bindGa({})
  getSubsectionItems(e, sectionIndexClicked) {
    let indexClicked;
    let msidVs;
    if (e === null) {
      //itemsAvailable = sectionDataAvail;
      indexClicked = sectionIndexClicked;
    } else {
      const eventTarget = e.target;
      //itemsAvailable = eventTarget.getAttribute('data-itemsavailable');
      indexClicked = eventTarget.getAttribute('data-index');
      msidVs = this.props.isEtimesVs
        ? eventTarget.getAttribute('data-msid')
        : '';
    }
    //const eventTarget = e.target;
    //const selectedMsid = eventTarget.getAttribute('data-msid');
    // const itemsAvailable = eventTarget.getAttribute('data-itemsavailable');
    // const indexClicked = eventTarget.getAttribute('data-index');
    const temp = this.state.category;

    analyticsWrapper('ga4', {
      event: 'user_click',
      type: temp?.name,
      text: e?.target?.textContent,
      label: e?.target?.href,
      category: 'text clicked',
    });

    if (this.props.isEtimesVs) {
      this.setState({
        showSectionChangeLoader: true,
      });
      this.getItemsEtimesVs(msidVs).then(data => {
        temp.data.items[0] = data?.data;
        temp.activeSection = indexClicked;
        this.setState({
          showSectionChangeLoader: false,
          category: temp,
        });
      });
    } else {
      const indexedSection = temp?.sections[indexClicked];
      const itemsAvailable =
        indexedSection.data &&
        indexedSection.data.items &&
        indexedSection.data.items.length;
      temp.updatedPath = indexedSection.path;
      if (!itemsAvailable) {
        this.setState({
          showSectionChangeLoader: true,
        });
        const pathToCallForData = indexedSection.path;
        this.getItems(
          pathToCallForData,
          temp?.data?.pg?.pp,
          temp?.data?.pg?.cp,
        ).then(data => {
          const finalData = data?.data?.data;
          temp.activeSection = indexClicked;
          indexedSection.data = finalData;
          temp.data = finalData;
          this.setState({
            showSectionChangeLoader: false,
            category: temp,
          });
          //eventTarget.setAttribute('data-itemsavailable', 'true');
          //this.state.category.sections[indexClicked].data = data.data.data;
        });
      } else {
        //const temp = this.state.category;
        temp.activeSection = indexClicked;
        temp.data = temp.sections[indexClicked].data;
        this.setState({
          category: temp,
        });
      }
    }
  }

  getGeoLocationMsid = () => {
    const geolocation = cookie.getCookie('geolocation');
    const url = `/vidpef/city-${geolocation}.cms`;
    return makeRequest.get(url, { isMobile: this.props.isWapView });
  };

  renderSubsections = () => {
    const { category } = this.state;
    if (category.sections) {
      // this.getGeoLocationMsid().then(data => {
      //   const cityMsid = data.city;

      // })
      const subsections = [];
      const moreSubsections = [];
      //let items;
      let index = 0;
      category.sections.forEach(section => {
        let activeClass = '';
        //let itemsAvailable = 'false';
        if (index === 0 && !section.data) {
          category.activeSection = 0;
          category.sections[0].data = category.data;
          //items = section.data.items;
          //itemsAvailable = 'true';
          this.setState({
            category,
          });
        }
        let eventForGA = '';
        if (typeof this.props.gaAction === 'string') {
          eventForGA = this.props.gaAction;
        } else {
          eventForGA = `VideoSlider-${category.name}`;
          eventForGA += category.titleSuffix ? `_${category.titleSuffix}` : '';
        }

        eventForGA += `#Tab-Select-${section.name}`;
        // if (section.data && section.data.items) {
        //   itemsAvailable = 'true';
        // }
        if (index === parseInt(category.activeSection, 10)) {
          activeClass = s.active;
        }
        if (
          index >= parseInt(category.moreLimit, 10) &&
          !this.props.isWapView
        ) {
          moreSubsections.push(
            <li
              className={`${s.tabItem} ${activeClass}`}
              key={section.msid}
              //data-itemsavailable={itemsAvailable}
              data-msid={section.msid}
              data-index={index}
              data-newga={eventForGA}
              onClick={this.getSubsectionItems}
            >
              {section.name}
            </li>,
          );
        } else {
          subsections.push(
            <li
              className={`${s.tabItem} ${activeClass}`}
              key={section.msid}
              //data-itemsavailable={itemsAvailable}
              data-msid={section.msid}
              data-index={index}
              data-newga={eventForGA}
              onClick={this.getSubsectionItems}
            >
              {section.name}
            </li>,
          );
        }
        index += 1;
      });
      if (moreSubsections.length) {
        subsections.push(
          <li className={`${s.tabItem} ${s['more-subsection']}`}>
            MORE
            <ul className={s.tabs}>{moreSubsections}</ul>
          </li>,
        );
      }
      return <ul className={s.tabs}>{subsections}</ul>;
    }
    return '';
  };

  handleCarouselNext = props => {
    //const eventTarget = e.target;
    if (typeof window !== 'undefined') {
      //triggering window scroll event to show lazy loaded images on carousel next click
      window.scrollTo(window.scrollX, window.scrollY - 1);
      window.scrollTo(window.scrollX, window.scrollY + 1);
    }
    const temp = this.state.category;
    const pginfo = temp.data.pg;
    const urlToCall = temp.updatedPath || temp.path;
    const curpg = parseInt(pginfo?.cp, 10);

    analyticsWrapper('ga4', {
      event: 'user_click',
      type: temp?.name,
      category: 'arrow click',
      arrow_clicked: 'Next Video',
    });

    if (curpg < parseInt(pginfo.tp, 10) && curpg < 3) {
      this.setState({
        showCarouselNextLoader: true,
      });
      this.getItems(urlToCall, pginfo.pp, curpg + 1).then(data => {
        const finalData = data.data.data;
        if (finalData.pg && finalData.items.length) {
          if (props.sliderBetweenList) {
            temp.data.items[props.sliderBetweenListIndex].data.pg =
              finalData.pg;
            finalData.items.forEach(item => {
              temp.data.items[props.sliderBetweenListIndex].data.items.push(
                item,
              );
            });
          } else {
            temp.data.pg = finalData.pg;
            finalData.items.forEach(item => {
              temp.data.items.push(item);
            });
          }
          //temp.data.items.push(finalData.items);
          this.setState({
            category: temp,
            showCarouselNextLoader: false,
          });
        }
      });
    }
  };

  updateStateData = updatedData => {
    const temp = this.state.category;
    if (updatedData.pg && updatedData.items.length) {
      temp.data.pg = updatedData.pg;
      updatedData.items.forEach(item => {
        temp.data.items.push(item);
      });
      //temp.data.items = updatedData.items;
      this.setState({
        category: temp,
      });
    }
  };

  getWatchLaterActivityId = obj => {
    let activityId = '';
    if (obj && obj._id) {
      activityId = obj._id;
    }

    return activityId.toString();
  };

  getListingPageSlidesToShow = (i, sliderBetweenList) => {
    const { slidesToShow = [], hasMrecAd } = this.props;
    let numberOfSlides;
    if (slidesToShow.length > 0 && slidesToShow[i]) {
      numberOfSlides = slidesToShow[i][hasMrecAd ? 'withAd' : 'withoutAd'];
    } else if (i === 0) {
      numberOfSlides = sliderBetweenList ? 4.5 : 5.5;
    } else if (i === 1) {
      numberOfSlides = sliderBetweenList ? 4 : 5;
    } else if (i === 2) {
      numberOfSlides = 4;
    }
    return numberOfSlides;
  };

  renderVideoSlider = (
    category = {},
    sliderBetweenList,
    sliderBetweenListIndex,
  ) => {
    let loaderClass = '';
    if (this.state.showSectionChangeLoader) {
      loaderClass = s.tabloader;
    }
    let sliderClass = '';
    if (sliderBetweenList) {
      sliderClass = s['slider-special-container'];
    }
    const spa = true;
    let actionForGA = `VideoSlider-${category.name}`;
    let secName = '';
    actionForGA += category.titleSuffix ? `_${category.titleSuffix}` : '';
    if (
      category &&
      category.sections &&
      category.activeSection &&
      Array.isArray(category.sections) &&
      category.sections[category.activeSection]
    ) {
      actionForGA += `-${category.sections[category.activeSection].name}`;
      secName = `${category.sections[category.activeSection].name}`;
    }
    // if (category.ext === 'true') {
    //   spa = false;
    // }
    let catData;
    if (typeof category !== 'undefined') {
      if (this.props.isEtimesVs) {
        catData = category?.data?.items[0]?.items;
      } else {
        catData = category?.data?.items;
      }
    } else {
      catData = [];
    }
    const list = (
      <div className={`${s['slider-box']} ${sliderClass} slider_video_listing`}>
        {sliderBetweenList ? (
          <Heading
            parentPath={this.props.parentPath}
            name={category?.name}
            path={category.path}
            titleSuffix={category.suffix}
            sliderBetweenList={sliderBetweenList}
          />
        ) : (
          ''
        )}
        <div className={`${s['item-container']} ${loaderClass}`}>
          {this.props.isWapView ? (
            catData.map((item, index) => (
              <Videocard
                categoryType={this.props.categoryType}
                parentPath={this.props.parentPath}
                ext={category.ext === 'true'}
                data={item}
                watchLater={!!this.props.watchLaterObj[item.id]}
                activityId={this.getWatchLaterActivityId(
                  this.props.watchLaterObj[item.id],
                )}
                addToWatchLater={this.addToWatchLater}
                removeFromWatchLater={this.removeFromWatchLater}
                spa={spa}
                viewMoreCard={index === catData.length - 1}
                isWapView={this.props.isWapView}
                viewMoreCardPath={category.updatedPath || category.path}
                language={category.lang}
                eventForGA={`${actionForGA}#Video_View-${index + 1}`}
                name={category?.name}
                isEtimesVs={this.props.isEtimesVs}
                index={`${index + 1}`}
                secName={secName}
              />
            ))
          ) : (
            <Carousel
              handleCarouselNextClick={
                sliderBetweenList ? null : this.handleCarouselNext
              }
              showCarouselNextLoader={
                sliderBetweenList ? null : this.state.showCarouselNextLoader
              }
              slidesToScroll={sliderBetweenList ? 4 : 5}
              slidesToShow={this.getListingPageSlidesToShow(
                0,
                sliderBetweenList,
              )}
              sliderBetweenList={sliderBetweenList}
              sliderBetweenListIndex={sliderBetweenListIndex}
              resposive={[
                {
                  breakpoint: 1510,
                  settings: {
                    slidesToShow: this.getListingPageSlidesToShow(
                      1,
                      sliderBetweenList,
                    ),
                    slidesToScroll: sliderBetweenList ? 4 : 5,
                  },
                },
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: this.getListingPageSlidesToShow(
                      2,
                      sliderBetweenList,
                    ),
                    slidesToScroll: 4,
                  },
                },
                {
                  breakpoint: 999,
                  settings: {
                    slidesToShow: sliderBetweenList ? 3.2 : 3,
                    slidesToScroll: sliderBetweenList ? 3.2 : 3,
                  },
                },
              ]}
            >
              {catData.map((item, index) => (
                <Videocard
                  categoryType={this.props.categoryType}
                  parentPath={this.props.parentPath}
                  ext={category.ext === 'true'}
                  data={item}
                  watchLater={!!this.props.watchLaterObj[item.id]}
                  activityId={this.getWatchLaterActivityId(
                    this.props.watchLaterObj[item.id],
                  )}
                  isWapView={this.props.isWapView}
                  addToWatchLater={this.addToWatchLater}
                  removeFromWatchLater={this.removeFromWatchLater}
                  sliderBetweenList={sliderBetweenList}
                  spa={spa}
                  language={category?.lang}
                  eventForGA={`${actionForGA}#Video_View-${index + 1}`}
                  isEtimesVs={this.props.isEtimesVs}
                  index={`${index + 1}`}
                  name={category?.name}
                  secName={secName}
                />
              ))}
            </Carousel>
          )}
        </div>
      </div>
    );
    return list;
    //);
  };

  getMoreItems = (type, lastSeenId, category) => {
    let url = '';
    if (type === 'history') {
      url = `https://myt.indiatimes.com/mytimes/myActivity?activityType=Watched&openNetworkId=sso&appKey=TOI&contID=ln_myActivity&size=5&lastSeenId=${lastSeenId}&after=false`;
    } else if (type === 'watchlater') {
      url = `https://myt.indiatimes.com/mytimes/myActivity?activityType=WishList&openNetworkId=sso&appKey=TOI&contID=ln_myActivity&size=5&lastSeenId=${lastSeenId}&after=false`;
    }
    jsonp(url, null, (err, data) => {
      if (data && data.length) {
        const msids = [];
        data.forEach(item => {
          msids.push(item.msid);
        });
        makeRequest
          .get(`/json/v_views_ajax.cms?msids=${msids.join('%2C')}`, {
            isMobile: this.props.isWapView,
          })
          .then(views => {
            const viewsData =
              views &&
              views.data &&
              views.data.v_views_ajax &&
              views.data.v_views_ajax.veiwcount;
            const updatedJson = userVideoDataJson({ data, views: viewsData });
            const temp = category;
            updatedJson.data.items.forEach(item => {
              temp.data.items.push(item);
              if (updatedJson.data.items.length < 10) {
                temp.showPagination = false;
              }
              this.setState({
                category: temp,
              });
            });
          });
        // const updatedJson = userVideoDataJson(data);
        // const temp = category;
        // updatedJson.data.items.forEach(item => {
        //   temp.data.items.push(item);
        // });
        // if (updatedJson.data.items.length < 10) {
        //   // const viewMore = document.getElementsByClassName('view-more')[0];
        //   // viewMore.className += ' d-none';
        //   temp.showPagination = false;
        // }
        // this.setState({
        //   category: temp,
        // });
      }
    });
  };

  renderVideoList = category => {
    const { adsData = [], isWapView } = this.props;
    const adsPositions = [];
    const numberOfVideosInOneRow = isWapView ? 2 : 10;
    if (adsData.length > 0) {
      adsData.forEach(ad => {
        adsPositions.push(
          parseInt(ad.position * numberOfVideosInOneRow - 1, 10),
        );
      });
    }
    let actionForGA = `VideoList-${category.name}`;
    actionForGA += category.titleSuffix ? `_${category.titleSuffix}` : '';
    if (this.props.gaAction) {
      actionForGA = this.props.gaAction;
    }
    let viewGa = 'Video_View';
    if (this.props.categoryType === 'article') {
      actionForGA = `ArticleList-${category.name}`;
      viewGa = 'Article_View';
    }
    const listing = [];
    //let index = 0;
    for (let i = 0; i < category.data.items.length; i += 1) {
      const item = category.data.items[i];
      if (this.props.isVideoShowPage && item.primeid) {
        actionForGA = 'Widget_PrimeWidget-Story_View_Related_Videos';
      }

      let isPrimeArticleWithVideo = !!item.primeid;
      if (this.props.categoryType === 'article') {
        isPrimeArticleWithVideo = true;
      }

      let indexOfAd = adsPositions.indexOf((i - 1) % 30);
      if (isTablet()) {
        indexOfAd = adsPositions.indexOf(i);
        if (isLandscape()) {
          indexOfAd = adsPositions.indexOf(i - 1);
        }
      }
      if (indexOfAd > -1) {
        listing.push(
          <AdCaller
            data={adsData[indexOfAd]}
            className={this.props.adClass}
            deviceType={isWapView ? 'mobile' : undefined}
            lazyClassName={s.lazyClassName}
          />,
        );
      }
      if (item.geoCountry && item.geoCountry !== this.props.currentCountry) {
        // show toiplus video for India Geo Only
        // eslint-disable-next-line no-continue
        continue;
      }
      if (item.tn === 'videoslider') {
        // const tempCategory = category;
        // tempCategory.sliderBetweenList = true;
        // tempCategory.sliderBetweenListIndex = i;
        // this.setState({ category: tempCategory });
        listing.push(this.renderVideoSlider(item, true, i));
      } else if (!item.primeid) {
        listing.push(
          <Videocard
            categoryType={this.props.categoryType}
            key={item.id}
            parentPath={this.props.parentPath}
            ext={item.ext === 'true' || category.ext === 'true'}
            data={item}
            hideWatchLater={isPrimeArticleWithVideo}
            watchLater={!!this.props.watchLaterObj[item.id]}
            activityId={this.getWatchLaterActivityId(
              this.props.watchLaterObj[item.id],
            )}
            isWapView={this.props.isWapView}
            addToWatchLater={this.addToWatchLater}
            removeFromWatchLater={this.removeFromWatchLater}
            theme={isWapView ? 'theme2' : 'default'}
            eventForGA={`${actionForGA}#${viewGa}-${i + 1}`}
            isEtimesVs={this.props.isEtimesVs}
            index={`${i + 1}`}
            name={category?.name}
          />,
        );
      } else if (item.primeid && this.props.isPrime) {
        listing.push(
          <Videocard
            categoryType={this.props.categoryType}
            key={item.id}
            parentPath={this.props.parentPath}
            ext={item.ext === 'true' || category.ext === 'true'}
            data={item}
            hideWatchLater={isPrimeArticleWithVideo}
            watchLater={!!this.props.watchLaterObj[item.id]}
            activityId={this.getWatchLaterActivityId(
              this.props.watchLaterObj[item.id],
            )}
            isWapView={this.props.isWapView}
            addToWatchLater={this.addToWatchLater}
            removeFromWatchLater={this.removeFromWatchLater}
            theme={isWapView ? 'theme2' : 'default'}
            eventForGA={`${actionForGA}#${viewGa}-${i + 1}`}
            isEtimesVs={this.props.isEtimesVs}
            index={`${i + 1}`}
            name={category?.name}
          />,
        );
      }
    }
    let paginationComponent = null;
    if (this.props.noPagination) {
      paginationComponent = null;
    } else if (!isWapView) {
      if (category.path === '/videos/elections/lok-sabha-election') {
        paginationComponent = null;
      } else {
        paginationComponent = (
          <Pagination
            pginfo={category.data.pg}
            path={
              category.path === '/videos/elections/lok-sabha-election'
                ? '/elections/lok-sabha-election/videos'
                : category.path
            }
            getItems={this.getItems}
            updateData={this.updateStateData}
          />
        );
      }
    }

    const list = (
      <div
        className={`${s['item-container']} ${isWapView ? s.mobileView : ''}`}
      >
        <div
          className={`${this.props.releatedArticle ? s.realtedAs_list : ''}`}
        >
          {listing}
        </div>
        {paginationComponent}
        {isWapView &&
        parseInt(category.data?.pg?.cp, 10) <= 9 &&
        parseInt(category.data?.pg?.cp, 10) <
          parseInt(category.data.pg.tp, 10) ? (
          <LazyLoad
            className="infinite-scoll"
            debounce={false}
            offsetVertical={400}
            key={category.data?.pg?.cp}
            onContentVisible={() => {
              this.getItems(
                category.path,
                category.data.pg.pp,
                parseInt(category.data?.pg?.cp, 10) + 1,
              ).then(data => this.updateStateData(data.data.data));
            }}
          >
            <div className={s.loader}>Loading more videos...</div>
          </LazyLoad>
        ) : (
          ''
        )}
      </div>
    );
    return list;
  };

  renderLinksList = category => {
    let list = '';
    if (category && category.data && category.data.items) {
      list = category.data.items.map(item => <LinksList item={item} />);
    }
    return <div className={s['links-list']}>{list}</div>;
  };

  renderItems = () => {
    const { category } = this.state;
    if (category.data && category.data.items) {
      switch (category.tn) {
        case 'videoslider':
          return this.renderVideoSlider(category, false);
        case 'linkslist':
          return this.renderLinksList(category);
        default:
          return this.renderVideoList(category);
      }
    } else {
      return '';
    }
  };

  render() {
    const { category } = this.state;
    const { releatedArticle } = this.props;
    const containerClass = classNames({
      [`${s['category-container']}`]: true,
      [`${releatedArticle}`]: releatedArticle,
      [`${s['mobile-category-container']}`]: this.props.isWapView,
      [`${s['links-list-container']}`]: this.props.linkslistData,
      [`${s['ad-container-width']}`]: this.props.hasMrecAd,
    });

    let headingType = 'h2';

    switch (category.tn) {
      case 'videoslider':
        break;
      case 'linkslist':
        break;
      case 'videolist':
        headingType = 'h4';
        break;
      default:
        if (this.props.categoryType === 'article') headingType = 'h4';
        else headingType = 'h1';
    }

    return (
      <div className={`${containerClass}`} key={category.msid}>
        <Heading
          parentPath={this.props.parentPath}
          name={category.name}
          path={category.path}
          titleSuffix={category.suffix}
          hideMoreBtn={this.props.hideMoreBtn}
          updatedPath={category.updatedPath}
          externalClick={category.ext}
          isWapView={this.props.isWapView}
          linkslistData={this.props.linkslistData}
          headingType={headingType}
        />
        {this.props.atfcontent && (
          <div className={s.atfWrap}>
            <AtfContent content={this.props.atfcontent} />
          </div>
        )}
        {category.description && !this.props.isWapView ? (
          <div className={s.description}>{category.description}</div>
        ) : (
          ''
        )}
        {this.renderSubsections()}
        {this.renderItems()}
      </div>
    );
  }
}

const mapDispatchtoProps = dispatch => ({
  toggleLoginBox: isOpen => {
    dispatch(toggleLoginBox(isOpen));
  },
});

const mapStateToProps = state => ({
  userData: _get(state, 'login.userData', {}),
});

CategoryListing.propTypes = {
  category: PropTypes.shape({}).isRequired,
  watchLaterObj: PropTypes.shape({}),
  isWapView: PropTypes.bool,
  adsData: PropTypes.shape({}),
  linkslistData: PropTypes.bool,
  hideMoreBtn: PropTypes.bool,
  parentPath: PropTypes.string,
  noPagination: PropTypes.bool,
  adClass: PropTypes.string,
  gaAction: PropTypes.string,
  geoData: PropTypes.shape({}),
  incrementAdsCounter: PropTypes.func,
  currentCountry: PropTypes.string,
  isVideoShowPage: PropTypes.bool,
  categoryType: PropTypes.string,
  releatedArticle: PropTypes.string,
  abAdskey: PropTypes.string,
  abTestExperimentId: PropTypes.shape({}),
  // eslint-disable-next-line react/no-unused-prop-types
  msid: PropTypes.string,
  slidesToShow: PropTypes.string,
  hasMrecAd: PropTypes.bool,
  isEtimesVs: PropTypes.bool,
  userData: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
    prcValue: PropTypes.number,
  }),
  toggleLoginBox: PropTypes.shape({}).isRequired,
};

CategoryListing.defaultProps = {
  isWapView: false,
  watchLaterObj: {},
  adsData: {},
  parentPath: {},
  linkslistData: false,
  hideMoreBtn: false,
  noPagination: false,
  adClass: '',
  gaAction: undefined,
  geoData: undefined,
  incrementAdsCounter: undefined,
  currentCountry: '',
  isVideoShowPage: false,
  categoryType: '',
  releatedArticle: '',
  abAdskey: '',
  abTestExperimentId: {},
  msid: '',
  slidesToShow: '',
  hasMrecAd: false,
  isEtimesVs: false,
  userData: undefined,
};

export default connect(mapStateToProps, mapDispatchtoProps)(CategoryListing);
